import {Injectable} from "@angular/core";
import {TrackableEntityActionService} from "./trackable-entity-action.service";
import {HttpClient} from "@angular/common/http";
import {NavigationService} from "./navigation.service";
import {Router} from "@angular/router";
import {CommonService} from "./common.service";
import {UserService} from "./user.service";
import {environment} from "../../../environments/environment";
import {EventDTO} from "../model/event.model";
import {FirebaseEventEnum} from "../enum/firebase-event.enum";
import {FirebaseService} from "./firebase.service";
import {PageResponseDTO} from "../model/page-response.model";
import {map} from "rxjs/operators";
import * as _ from 'lodash';

@Injectable(
  {providedIn: 'root'}
)
export class EventActionService extends TrackableEntityActionService<EventDTO> {

  constructor(private firebaseService: FirebaseService,
              http: HttpClient,
              navigationService: NavigationService,
              router: Router,
              commonService: CommonService,
              userService: UserService) {

    super(http, navigationService, router, userService, commonService, environment.host + "/users/actions/events");
  }

  getFavoriteEvents() {
    return this.http.get<PageResponseDTO<EventDTO>>(environment.host + "/users/me/events/favorite").pipe(
      map((response) => {
        this._savedEventsId = _.map(response.results, 'id');
        return response.results;
      })
    );
  }

  public override countCalendarFB(event: EventDTO) {
    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'add-calendar'
    });
  }

  public override countOpenFB(event: EventDTO) {
    console.error("Method not implemented. - EventActionService.countOpenFB");
  }

  public override countCallFB(event: EventDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'call-number'
    });
  }

  public override countWhatsappFB(event: EventDTO) {
    console.error("Method not implemented. - EventActionService.countWhatsappFB");
  }

  public override countNavigateFB(event: EventDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'navigate'
    });
  }

  public override countInstagramFB(event: EventDTO) {
    console.error("Method not implemented. - EventActionService.countInstagramFB");
  }

  public override countFacebookFB(event: EventDTO) {
    console.error("Method not implemented. - EventActionService.countFacebookFB");
  }

  public override countExternalLinkFB(event: EventDTO) {
    console.error("Method not implemented. - EventActionService.countExternalLinkFB");
  }

  public override countShareFB(event: EventDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'share'
    });

  }

  public override toggleFavoriteFB(event: EventDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      event_name: event.name,
      event_id: event?.id,
      event_action: 'favorite'
    });

  }

}
